export default {
  component: () => import('./page.vue'),
  path: '/device/:serial?',
  name: 'device',
  meta: {
    title: '设备详情',
    auth: true,
  },
};
